import React, {useEffect, useState} from "react";
import cardBg from "@assets/img/cardBg.svg";
import openedCardBg from "@assets/img/opendedCardBg.svg";
import classNames from "classnames";

function CardsListItem({card, ...restProps}) {
    const [cardItem, setCardItem] = useState({
        suit: 0,
        type: 0
    })
    

    useEffect(() => {
        let timer = setTimeout(() => {
            setCardItem(card);
        }, 500)
        return () => {
            clearTimeout(timer);
        }
    }, [card])
    return(

        <div className={classNames("cards-list-item card", {show: card && card.type })} {...restProps}>
            <div className={classNames("flip-card", {active: cardItem && cardItem.type })}>
                <div className="flip-card-inner">
                    <div className="flip-card-front">
                        <img src={cardBg} alt={cardBg} />
                    </div>
                    <div className="flip-card-back">
                        <img src={openedCardBg} alt={openedCardBg} />
                        <i className={`cardIcon icon-${cardItem && cardItem.type}${cardItem && cardItem.suit}`}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CardsListItem;